import React from "react";
import {
    BlockQuote,
    GoToAction,
    Cite,
    Deck,
    Heading,
    ListItem,
    List,
    Quote,
    Slide,
    Text
} from "spectacle";

import Logo from '../components/Logo';

const Hello = ({ content }) =>
    <div>
        <Heading size={2} fit caps lineHeight={1} textColor="secondary">
            SINTEL.AI
        </Heading>
        <Text margin="40px 0 0" textColor="tertiary" size={1} fit>
            {content.title}
        </Text>
        <Text margin="40px 0 0" textColor="secondary" size={5} fit bold caps>
            {content.subtitle}
        </Text>
    </div>

export default Hello;


// WEBPACK FOOTER //
// ./src/slides/Hello.js